import { useEffect } from 'react';
import { useHistory } from 'react-router-dom';
import { StepsResolution886 } from '../../../enums';
import { useResolution886Report } from '@/context/Resolution886Report';
import { useUpdateStepResolution886Report } from '@/hooks/v2/resolution-886/useUpdateStepResolution886Report';

enum StepsEnum {
	STEP_ZERO = 0,
	STEP_ONE = 1,
	STEP_TWO = 2,
	STEP_THREE = 3,
	STEP_FOUR = 4
}

export function useStepControl() {
	const history = useHistory();
	const { mutate: updateStep } = useUpdateStepResolution886Report();
	const { form, report, currentStep, reviewConsolidated, handleCurrentStep } = useResolution886Report();

	function handleUpdateStepOrSkipCurrentStep(isExistsReportId: boolean, step: StepsResolution886): void {
		isExistsReportId ? handleUpdateStep(step) : handleCurrentStep(step);
	}

	async function handleStepNavigationClickUpdate(step: number): Promise<void> {
		if (step === StepsEnum.STEP_ZERO) {
			const payload = StepsResolution886.VIDEO_SELECTION;
			handleUpdateStepOrSkipCurrentStep(!!report.id, payload);
			return;
		}

		if (step === StepsEnum.STEP_ONE) {
			const payload = StepsResolution886.GENERAL_INFORMATION;
			handleUpdateStepOrSkipCurrentStep(!!report.id, payload);
			return;
		}

		if (step === StepsEnum.STEP_TWO) {
			handleUpdateStep(StepsResolution886.ASSESSMENT);
			return;
		}

		if (step === StepsEnum.STEP_THREE) {
			handleUpdateStep(StepsResolution886.ACTION_PLAN);
			return;
		}

		if (step === StepsEnum.STEP_FOUR) {
			handleCurrentStep(StepsResolution886.RESULT);
			return;
		}
	}

	function handleRedirectToReport(): void {
		history.push(`/custom-reports/resolution-886/report/${report.id}`);
	}

	function handleUpdateStep(step: number, next: boolean = true): void {
		if (!next) {
			handleRedirectToReport();
		}

		const values = form.getFieldsValue(['general_information']);
		const { organization_id, company_id, review_id } = values.general_information;

		const payload = {
			report_id: report.id!,
			organization_id,
			company_id,
			review_id,
			step
		};

		updateStep(payload, {
			onSuccess: () => {
				handleCurrentStep(step);
			}
		});
	}

	useEffect(() => {
		handleStepNavigationClickUpdate(currentStep);
	}, [currentStep]);

	return {
		currentStep,
		reviewConsolidated,
		handleCurrentStep,
		handleUpdateStep
	};
}
